export default {
  composition: 'Composition',
  description: 'Description',
};
